export function hasElements<T = unknown>(
  value:
    | Array<number>
    | null
    | undefined
    | string
    | number
    | Array<string>
    | Array<T>
): boolean {
  return Array.isArray(value) && value.length > 0;
}
